<template>
  <div class="d-flex flex-column">
    <template v-if="!plans.length">
      <vue-content-loading :width="800" :height="450">
        <rect v-for="x in 15" :key="x" x="10" :y="15*x*1.4" rx="5" ry="5" width="720" height="6" />
      </vue-content-loading>
    </template>
    <template v-else>
      <div class="plans-wrap mb-3">
        <div class="row">
          <div class="col-sm-4 mb-3" v-for="plan in plans"
               :key="plan.recurly_id"
          >
            <Plan :plan="plan" :job="job" @planSent="$emit('getJob')" />
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import axios from 'axios';
import Plan from './subcomponents/Plan.vue';

export default {
  name: 'JobPlans',
  components: { Plan },
  props: {
    job: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    plans: [],
  }),
  mounted() {
    this.getPlans();
  },
  methods: {
    getPlans() {
      axios
        .get(`/recurly/api/plans`)
        .then(res => {
          this.plans = res.data.data;
        })
        .catch(err => console.log(err));
    },
  },
};
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/jobs/JobPlans.vue